import { useCallback } from 'react'
import { useHistory } from 'react-router-dom'
import { getBackTarget, NavigationStackEntry, popBackTarget } from './navigationStack'

export const useStackBack = (fallback: NavigationStackEntry) => {
  const history = useHistory()
  const target = getBackTarget()
  const label = target?.label ?? fallback.label

  const goBack = useCallback(() => {
    const entry = popBackTarget() ?? fallback
    history.push(entry.url)
  }, [fallback, history])

  return { label, goBack, hasStack: !!target }
}
